<template>
  <div class="triger-container">
    <div class="triger">
      <p class="title">{{title}}</p>
      <div class="slects">
        <el-form
          :model="localForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm">
          <div class="slect-top">
            <el-select
              @change='actionTypeChange'
              v-model="form.params.actionType"
              placeholder="请选择执行动作">
              <el-option
                v-for="(item, index) in options1"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select
              :disabled="!form.params.actionType"
              v-if="form.params.actionType==='2'"
              @change='productTypeChange'
              v-model="form.params.productKey"
              placeholder="请选择规则">
              <el-option
                v-for="(item, index) in options2"
                :key="index"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
            </el-select>
            <el-select
              :disabled="!form.params.actionType"
              v-if="form.params.actionType==='2'"
              @change='productTypeChange'
              v-model="form.params.productKey"
              placeholder="执行操作">
              <el-option
                v-for="(item, index) in options2"
                :key="index"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
            </el-select>
            <el-select
              :disabled="!form.params.actionType"
              v-if="form.params.actionType==='1'"
              @change='productTypeChange'
              v-model="form.params.productKey"
              placeholder="请选择产品">
              <el-option
                v-for="(item, index) in options2"
                :key="index"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
            </el-select>
            <el-select
              :disabled="!form.params.productKey"
              v-if="form.params.actionType==='1'"
              @change='productChange'
              v-model="form.params.deviceName"
              placeholder="请选择设备">
              <el-option
                v-for="(item, index) in options3"
                :key="index"
                :label="item.deviceName"
                :value="item.deviceName">
              </el-option>
            </el-select>
          </div>
          <div v-if="form.params.actionType==='1'" class="select-bottom">
            <el-select
              :disabled="!form.params.deviceName"
              @change='propChange'
              v-model="form.params.propertyName"
              placeholder="请选择属性/服务">
              <el-option
                v-for="(item,index) in options4"
                :key="index"
                :label="item.name"
                :value="item.identifier">
              </el-option>
            </el-select>
            <el-select
              @change="inputChange1"
              v-if="resultType===1"
              :disabled="!form.params.propertyName"
              v-model="localForm.propertyValue"
              placeholder="请选择值">
              <el-option
                v-for="item in options5"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-form-item
              v-if="resultType===2"
              label=""
              prop="propertyValue">
              <el-input
                @input="inputChange"
                v-model="localForm.propertyValue"
                :disabled="!form.params.propertyName"
                placeholder="请输入数值">
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <el-button
      type="text"
      @click="deleteItem">
      删除
    </el-button>
  </div>
</template>

<script>
import { deviceList, getProductProp } from '@/api/ruleEngine.js'
// eslint-disable-next-line no-unused-vars
let compareRange = {}
let compareValue = '<'
const validatePass = function (rule, value, callback) {
  if (compareValue === 'in') {
    let arr = []
    try {
      arr = JSON.parse(value)
    } catch (e) {
      callback(new Error('例如输入[1,2,3,4]'))
      return
    }
    if (!Array.isArray(arr)) {
      callback(new Error('例如输入[1,2,3,4]'))
    } else {
      for (const item in arr) {
        if (item > compareRange.max || item < compareRange.min) {
          callback(new Error('超过限定数字范围'))
          break
        }
      }
    }
  } else if (compareValue === 'between') {
    const arr = JSON.parse(value)
    if (!Array.isArray(arr)) {
      callback(new Error('例如输入[1,4]'))
    } else {
      for (const item in arr) {
        if (item > compareRange.max || item < compareRange.min) {
          callback(new Error('超过限定数字范围'))
          break
        }
      }
    }
  } else {
    var value1 = parseFloat(value)
    if (value1 > compareRange.max || value1 < compareRange.min) {
      callback(new Error('超过限定数字范围'))
    }
    callback()
  }
}
export default {
  name: 'actionItem',
  data () {
    return {
      propName: '',
      resultType: 1,
      rules: {
        propertyValue: [
          {
            required: true,
            message: '请输入温度',
            trigger: 'blur'
          },
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ]
      },
      localForm: { propertyValue: '' },
      options1: [{
        value: '1',
        label: '设备输出'
      }, {
        value: '2',
        label: '规则输出'
      }],
      options2: [],
      options3: [],
      options4: [],
      options5: [],
      value1: '',
      value2: '',
      value3: '',
      value4: '',
      value5: ''
    }
  },
  props: {
    itemIndex: {
      type: Number
    },
    title: {
      type: String,
      default: '执行动作'
    },
    form: {
      type: Object
    },
    productList: {
      type: Array
    }
  },
  watch: {
    form: {
      handler (value) {
        if (!value.params.productKey) return
        this.localForm.propertyValue = value.params.propertyValue
        compareValue = value.params.compareType
        deviceList({ productKey: value.params.productKey }).then(res => {
          this.options3 = res.data
        })
        getProductProp({ productKey: value.params.productKey }).then(res => {
          this.propData = res.data.thingModel
          if (value.params.actionType === '1') {
            this.options4 = this.propData.properties
            const propertyItem = this.options4.filter(item => {
              return item.identifier === this.form.params.propertyName
            })[0]
            console.log('propertyItem------condition', propertyItem)
            if (propertyItem.dataType.type === 'bool' || propertyItem.dataType.type === 'enum') {
              this.options5 = [{
                value: '=='
              }]
              const specs = propertyItem.dataType.specs
              const keys = Object.keys(specs)
              this.options5 = keys.map(index => {
                return {
                  label: specs[index],
                  value: index
                }
              })
              this.resultType = 1
            } else {
              this.options5 = [{
                value: '>'
              }, {
                value: '>='
              }, {
                value: '<='
              }, {
                value: '!='
              }, {
                value: '=='
              }, {
                value: 'in'
              }, {
                value: 'between'
              }]
              this.resultType = 2
              compareRange = propertyItem.dataType.specs
            }
          } else if (value.params.conditionType === '2') {
            this.options5 = this.propData.events
          } else {
            this.options5 = [{
              identifier: '1',
              name: '下线'
            }, {
              identifier: '2',
              name: '上线'
            }]
          }
        })
      },
      immediate: true
    },
    productList: {
      handler (value) {
        this.options2 = value
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    deleteItem () {
      this.$confirm('此操作将删除执行动作，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('deleteItem')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    actionTypeChange (value) {
      this.form.params.productKey = ''
      this.form.params.deviceName = ''
      this.form.params.propertyName = ''
      this.form.params.conditionType = ''
      this.form.params.compareType = ''
      this.form.params.propertyName = ''
      this.localForm.propertyValue = ''
    },
    productTypeChange (productKey) {
      deviceList({ productKey }).then(res => {
        this.options3 = res.data
      })
    },
    productChange (identifier) {
      this.form.params.propertyName = ''
      this.localForm.propertyValue = ''
      getProductProp({ productKey: this.form.params.productKey }).then(res => {
        this.options4 = res.data.thingModel.properties
      })
      this.$forceUpdate()
    },
    propChange (identifier) {
      this.localForm.propertyValue = ''
      const Item = this.options4.filter(propItem => {
        return propItem.identifier === identifier
      })[0]
      const specs = Item.dataType.specs
      const keys = Object.keys(specs)
      const type = Item.dataType.type
      if (type === 'bool' || type === 'enum') {
        this.resultType = 1
        this.options5 = Item.dataType.specs
      } else {
        this.resultType = 2
      }
      this.options5 = keys.map(index => {
        return {
          label: specs[index],
          value: index
        }
      })
    },
    inputChange (value) {
      const prop = this.form.params.propertyName
      const propertyItems = {}
      propertyItems[prop] = value
      this.form.params.propertyItems = propertyItems
      this.form.params.propertyValue = value
    },
    inputChange1 (value) {
      const prop = this.form.params.propertyName
      const propertyItems = {}
      propertyItems[prop] = value
      this.form.params.propertyItems = propertyItems
      this.form.params.propertyValue = value
    }
  }
}
</script>

<style lang="less" scoped>
  .triger-container {
    display: flex;
    flex-direction: row;
    align-items: start;

    .el-button {
      margin: 20px 10px;
    }
  }

  .triger {
    border-radius: 5px;
    width: 75%;
    min-width: 950px;
    margin: 10px 0;
    padding: 8px 15px;
    background-color: #efeeee;

    .slects {
      width: 900px;

      .el-form-item {
        margin-bottom: 0px;
      }

      .el-select {
        margin: 5px 0;
        margin-right: 30px;
      }

      .el-input {
        width: 200px;
      }

      .select-bottom {
        display: flex;
        flex-direction: row;

        .el-form-item {
          margin-top: 5px;
        }
      }
    }
  }
</style>
